<template>
  <fragment>
    <b-navbar-toggle target="nav_collapse" v-if="!hideNavbarToggle" />
    <b-collapse is-nav id="nav_collapse">
      <b-navbar-nav class="main-menu">
        <slot name="nav-items" />
        <!-- help dropdown menu -->
        <div class="display-items">
          <div class="nav-buttons">
            <b-nav-item class="ml-2">
              <b-button
                v-if="!isSwitchGuestRolesPage"
                @click="showModal"
                variant="v2_primary"
                class="nav-button"
              >
                Refer a Colleague
              </b-button>
            </b-nav-item>
          </div>
          <div class="nav-buttons-bottom">
            <b-nav-item class="ml-2">
              <i
                class="mdi mdi-bell-ring-outline font_size_1250rem"
                aria-hidden="true"
              />
            </b-nav-item>
            <b-nav-item
              class="ml-2"
              :to="
                $store.getters.userIsMSSRecruiter ||
                $store.getters.userHasInvalidEmail
                  ? '/recruiter/faq'
                  : '/help'
              "
            >
              <i
                class="mdi mdi-help-circle-outline font_size_1250rem"
                aria-hidden="true"
              />
            </b-nav-item>
            <b-nav-item class="ml-2 line-just">
              <span class="h-100 border_left_1 border_white">&nbsp;</span>
            </b-nav-item>
            <!-- user dropdown menu -->
            <user-nav-section v-if="userEmail" :user-email="userEmail" :userName="userName" />
            <template v-else>
              <b-nav-item to="/login" :class="{'mx-2' : isGuestRecruiter}" :disabled="isLoginPage">
                <span class="nav-link-title mr-1 text_underline">Sign in</span>
              </b-nav-item>
              <b-nav-item
                v-if="!isGuestRecruiter"
                :to="
                  currentRole === guestUserRoles.ROLE_RECRUITER
                    ? '/recruiter/sign-up'
                    : '/registration'
                "
                :disabled="isRegistrationPage"
              >
                <b-button variant="kowloon" class="nav-link-title mr-1 py-2">
                  Sign up
                </b-button>
              </b-nav-item>
            </template>
          </div>
        </div>
      </b-navbar-nav>
    </b-collapse>
    <portal to="info-popups">
      <!--  Refer a Colleague Modal  -->
      <refer-colleague-modal
        v-if="isReferModalVisible"
        v-model="isReferModalVisible"
        @cancel="onHideReferModal"
      />
    </portal>
  </fragment>
</template>

<script>
import UserNavSection from '@/components/layouts/navigation-bar/UserNavSection';
import ReferColleagueModal from '@/components/dashboard/ReferColleagueModal';
import ReferColleagueMixin from '@/mixins/ReferColleagueMixin';
import { GUEST_USER_ROLES } from '@/store';
import { ROUTES } from '@/router';

export default {
  name: 'NavigationMenu',
  props: {
    userEmail: String,
    userName: String,
  },
  mixins: [ReferColleagueMixin],
  components: {
    UserNavSection,
    ReferColleagueModal,
  },
  data: function () {
    return {
      guestUserRoles: GUEST_USER_ROLES,
    };
  },
  computed: {
    currentRole: function () {
      return this.$store.state.guestCurrentRole;
    },
    isSwitchGuestRolesPage: function () {
      return this.$route.path.indexOf(ROUTES.GUEST_SWITCH_ROLES_PAGE) === 0;
    },
    isGuestRecruiter: function () {
      return this.$store.getters.isGuestRecruiter;
    },
    isRegistrationPage: function () {
        return this.$route.path === '/registration';
    },
    isLoginPage: function () {
      return this.$route.path === '/login';
    },
    hideNavbarToggle() {
      if(this.$route.path == '/recruiter/ico' && !this.$store.state.user){
        return true;
      }
      if(this.$route.meta){
        return this.$route.meta.hideNavbarToggle || false;
      }
      return false;
    }
  },
  methods: {
    showModal: function () {
      if (this.isGuestRecruiter) {
        this.$root.$emit('show-coming-soon-modal');
      } else {
        this.onShowReferModal();
      }
    },
  },
};
</script>

<style scoped>
.nav-buttons {
  display: flex;
}
.nav-buttons-bottom {
  display: flex;
}
.display-items {
  display: flex;
}
@media (max-width: 991px) {
  .nav-buttons {
    margin-bottom: 10px;
  }
  .line-just {
    display: none !important;
  }
}
@media (min-width: 320px) and (max-width: 945px) {
  .display-items {
    display: block;
  }
}
@media (min-width: 320px) and (max-width: 400px) {
  .nav-buttons {
    display: block;
  }
  .btn-bottom {
    margin-bottom: 10px;
  }
}
</style>
<style scoped lang="scss">
@import '../../../../sass/variables_mixins.scss';
.navbar-dark {
  .navbar-nav {
    //sm
    @media (max-width: 767px) {
      justify-content: space-around;
    }
    //md
    @media (min-width: 991px) {
      flex-direction: row;
      justify-content: space-around;
    }
    .nav-item {
      .nav-link {
        //sm
        @media (max-width: 767px) {
          padding: 0;
        }
        //lg
        @media (min-width: 991px) {
          padding-left: 0.5rem;
          padding-right: 0.5rem;
        }
      }
    }
  }
}
.nav-button {
  border: 1px solid #ffffff;
  background-color: $phairify_v2_color_primary_teal;
  color: #ffffff;
  font-family: $phairify_font_montserrat;
  &:hover {
    color: $phairify_v2_color_primary_teal !important;
    background-color: #ffffff !important;
  }
}
</style>
